export default [
	{
		path: '/report/list/:id?',
		name: 'reportList',
		component: () => import('@/views/report-manage/list.vue'),
		meta: { title: '健康报告' }
	},
	{
		path: '/report/detail/:id',
		name: 'reportDetail',
		component: () => import('@/views/report-manage/detail.vue'),
		meta: { title: '健康报告' }
	},
	{
		path: '/reportDetail/:type/:id',
		name: 'reportDetail',
		component: () => import('@/views/report-manage/detail.vue'),
		meta: { title: '健康报告' }
	}
]
